export default __webpack_public_path__ + "static/media/icons.18df003f.svg";